import { gql } from '@apollo/client'
import { createAuthClient } from './client'
import { IInventoryRepository } from 'domain/repositories/Inventory'
import { Inventory, InventoryInput } from 'domain/entities/Inventory'

export class GraphQLInventoryRepository implements IInventoryRepository {
  constructor(private getToken: () => Promise<string>) {}
  private client = createAuthClient(
    process.env.REACT_APP_INVENTORY_GRAPHQL_URL!,
    this.getToken
  )

  async fetchAll(): Promise<Inventory[]> {
    const QUERY = gql`
      query InventoriesByUser {
        inventoriesByUser {
          id
          title
          createdAt
        }
      }
    `
    const { data } = await this.client.query<{
      inventoriesByUser: Inventory[]
    }>({
      query: QUERY,
    })
    return data.inventoriesByUser
  }

  async create(inventory: InventoryInput): Promise<void> {
    const MUTATION = gql`
      mutation CreateInventory($title: String!) {
        createInventory(title: $title) {
          id
        }
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: {
        title: inventory.title,
      },
    })
  }

  async update(inventory: InventoryInput): Promise<void> {
    const MUTATION = gql`
      mutation UpdateInventory($id: String!, $title: String) {
        updateInventory(id: $id, title: $title) {
          id
          title
          createdAt
        }
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: { ...inventory },
    })
  }
  async delete(id: string): Promise<void> {
    const MUTATION = gql`
      mutation DeleteInventory($id: String!) {
        deleteInventory(id: $id)
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: { id },
    })
  }
}
